// extracted by mini-css-extract-plugin
export default {"title":"get-delete-product-messages_title__vJP3J","button":"get-delete-product-messages_button__5BZRH"};